import { ActionTree } from "vuex";
import { State } from "./state";
import { findAll } from "@/store/Crud/functions/actions";

export default <ActionTree<State, any>>{
  findAll,
};
